import type { AdGallerySlide } from "../../../../actions/ad/adGallery";

export function getPreviousPage(currentPage: number, numPages: number): number {
  return currentPage - 1 >= 0 ? currentPage - 1 : numPages - 1;
}

export function getNextPage(currentPage: number, numPages: number): number {
  return (currentPage + 1) % numPages;
}

export function hasPageBeenFetched(
  page: number,
  slides: AdGallerySlide[],
): boolean {
  return slides.some((slide) => slide.currentPage === page);
}

export function randomizePage(maxCounter: number): number {
  if (maxCounter === 0) {
    return 0;
  }
  return Math.floor(Math.random() * maxCounter);
}

export function decode(html: string): string {
  return html.replace(
    /&(?:#(\d+)|#x([0-9a-fA-F]+)|([a-zA-Z]+));?/g,
    (
      $0: string,
      decDigits: string,
      hexDigits: string,
      namedReference: string,
    ) => {
      if (decDigits) {
        // Decode decimal escapes, e.g., `&#119558;`
        const codePoint = parseInt(decDigits, 10);
        return codePoint > 0x10ffff
          ? "\uFFFD"
          : String.fromCodePoint(codePoint);
      }

      if (hexDigits) {
        // Decode hexadecimal escapes, e.g., `&#x1D306;`
        const codePoint = parseInt(hexDigits, 16);
        return codePoint > 0x10ffff
          ? "\uFFFD"
          : String.fromCodePoint(codePoint);
      }

      if (namedReference) {
        // Decode named character references, e.g., `&amp;`
        const decodeMap: { [key: string]: string } = {
          amp: "&",
          lt: "<",
          gt: ">",
          quot: '"',
          apos: "'",
        };
        return decodeMap[namedReference] || $0;
      }
      return $0;
    },
  );
}
